import styled from '@emotion/styled';
import { em } from 'polished';
import { forwardRef, memo } from 'react';

import { css, scale } from '~/css';

import * as ArrowButton from './ArrowButton';
import FeatureCard from './FeatureCard';
import RepeatContainer from './RepeatContainer';
import { CarouselMode, CarouselProps } from './types';

const Container = styled('div')(css({}));

const ArrowButtonWrapper = styled('div')((props: { mode: CarouselMode }) =>
  css({
    width: props.mode === 'landscape' ? '100%' : ['100%', 500, '100%'],
    position: 'absolute',
    top: ['48%', '48%', '50%'],
    left: '50%',
    transform: 'translateX(-50%) translateY(-50%)',
    zIndex: 1,
  })(props),
);

const MobileCarousel = forwardRef<HTMLDivElement, CarouselProps>(
  ({ items, currentIndex, mode, goPrev, goNext, onTransitionEnd }, forwardedRef) => {
    return (
      <Container>
        <div css={{ position: 'relative' }}>
          <ArrowButtonWrapper mode={mode}>
            <ArrowButton.Prev onClick={goPrev} />
            <ArrowButton.Next onClick={goNext} />
          </ArrowButtonWrapper>
          <RepeatContainer
            ref={forwardedRef}
            currentIndex={currentIndex}
            onTransitionEnd={onTransitionEnd}
            panelSize={mode === 'landscape' ? scale(580) : scale(500 + 100)}
            css={css({
              paddingTop: em(18),
              paddingBottom: '2.5em',
              paddingX: '1em',
              margin: '0 -1em',
            })}
          >
            {items.map((item, index) => (
              <FeatureCard
                key={index}
                title={item.title}
                description={item.description}
                sharp={item.image.localFile.childImageSharp}
                mode={mode}
                active={index === currentIndex}
              />
            ))}
          </RepeatContainer>
        </div>
      </Container>
    );
  },
);

export default memo(MobileCarousel);
